<script lang="ts">
  import ProductImage from "../ProductImage.svelte";
  import type { Storefront } from "@shared/types/Storefront";
  import type { ImageObj } from "@shared/types/Images";
  export let storefront: Storefront;

  let headerObj: ImageObj;
  let logoObj: ImageObj;
  $: {
    headerObj = { cloudinary_image_url: storefront.header_image_cloudinary_url };
    logoObj = { cloudinary_image_url: storefront.logo_image_cloudinary_url };
  }

</script>

<div data-grid-area="header" id="header_and_logo">
  {#if headerObj.cloudinary_image_url}
    <ProductImage
      product={headerObj}
      fizz={true}
      eTrimMode={false}
      height="300"
      maxHeight={"300px"}
    />
  {:else}
    <div class="fizz-placeholder" style="width: 100%; height: 0; padding-bottom: 21.43%" />
  {/if}
</div>
{#if storefront.enable_logo}
  <div data-grid-area="avatar" class="fizz-avatar fizz-avatar-{storefront.logo_alignment}">
    <ProductImage product={logoObj} fizz={true} eTrimMode={false} maxHeight={"150px"} />
  </div>
{/if}
